import App from './components/app';
import { setupAnalytics } from 'src/ui/functions/analytics';

setupAnalytics();
export default App;
